import Carousel from './carousel';

class HeroNav {
  public items: NodeListOf<HTMLElement> | null;
  public heroNav: Element;
  public heroNavMobileSlider: Element;
  public dropdowns: HTMLCollection;
  public mobileSlider: any;

  clearDropdownHoveredItems(){
    document.querySelectorAll('.dropdown-wrapper.is-open').forEach(function(el, i) {
      el.classList.remove('is-open');
    });

    document.querySelectorAll('.a-dropdown.is-hover').forEach(function(el, i) {
      el.classList.remove('is-hover');
      el.nextElementSibling?.classList.remove('is-active');
      el.nextElementSibling?.classList.remove('m-nav-dropdown__bg--default');
      //(el.nextElementSibling?.querySelector('video') as HTMLVideoElement).pause();
    });
  }

  resetInitialState(){
    this.heroNav.classList.add('is-hover-a-dropdown');
    this.dropdowns[0].classList.add('is-open');
    this.items?.[0].classList.add('is-hover');

    setTimeout(() => {
      this.items?.[0].parentElement?.querySelector('.m-nav-dropdown__bg')?.classList.add('is-active');
      this.items?.forEach((item) => {
        item.classList.add('fade-in');
      });
    }, window.sessionStorage.getItem('preloader') === 'played' ? 500 : 3500);
  }

  bindings() {
    if (this.heroNav && this.dropdowns && this.items) {
      this.resetInitialState()
    }

    if (this.items) {
      Object.values(this.items).forEach((item) => {
        item.addEventListener('mouseover', (e: any) => {
          if (!e.currentTarget.classList.contains('is-hover')) {
            e.currentTarget.classList.add('is-hover');
          }
          if (!e.currentTarget.nextElementSibling.classList.contains('is-active')) {
            e.currentTarget.nextElementSibling.classList.add('is-active');
          }
          //(e.currentTarget.nextElementSibling?.querySelector('video') as HTMLVideoElement).play();
          if (!this.heroNav.classList.contains('is-hover-a-dropdown')) {
            this.heroNav.classList.add('is-hover-a-dropdown');
          }
        });
      });

      Object.values(this.dropdowns).forEach((dropdown) => {
        dropdown.addEventListener('mouseover', (e: any) => {
          this.clearDropdownHoveredItems();
          if (!e.currentTarget.classList.contains('is-open')) {
            e.currentTarget.classList.add('is-open');
          }
        });
      });
    }
  }

  cache() {
    this.items = document.querySelectorAll('.js-hero-nav-item');
    this.heroNav = document.getElementsByClassName('js-o-hero-nav')[0];
    this.dropdowns = document.getElementsByClassName('dropdown-wrapper');
    this.heroNavMobileSlider = document.getElementsByClassName('js-o-hero-nav-mobile-slider')[0];
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default HeroNav;
